import request from '@/middleware/request'

const getTtsDictionaryList = () => {
  return request({
    url: '/tts_dictionaries',
    method: 'get'
  })
}

const getTtsDictionary = id => {
  return request({
    url: `/tts_dictionaries/${id}`,
    method: 'get'
  })
}

const createTtsDictionary = data => {
  return request({
    url: '/tts_dictionaries',
    method: 'post',
    data
  })
}

const updateTtsDictionary = (id, data) => {
  return request({
    url: `/tts_dictionaries/${id}`,
    method: 'put',
    data
  })
}

const deleteTtsDictionary = id => {
  return request({
    url: `/tts_dictionaries/${id}`,
    method: 'delete'
  })
}

const importTtsDictionary = formData => {
  return request({
    url: '/tts_dictionaries/import',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

const exportTtsDictionary = id => {
  return request({
    url: `/tts_dictionaries/export/${id}`,
    method: 'get',
    responseType: 'blob',
    data
  })
}

export default {
  getTtsDictionary,
  getTtsDictionaryList,
  createTtsDictionary,
  updateTtsDictionary,
  deleteTtsDictionary,
  importTtsDictionary,
  exportTtsDictionary
}
